//请假申请流程
import React from 'react'
import { connect } from 'react-redux'
import { doLeaveApplyFlow, doGetDriverInfo } from '../reducers/actions'
import { doOneDispatch, doDispatchs, copyListValuesById, nullDate, TDate } from '../public/utility'
const doPrepare = (dispatch, props) => {
    const handlerConfirm = () => {
        const { onSave, onClose, id, action, confirmMsg } = props
        const changedValues基本信息 = {}
        Tyan.pubForm.showConfirm(confirmMsg || '确定执行？',
            () =>
                doOneDispatch(dispatch, [doLeaveApplyFlow, { id, action, changedValues基本信息 }])
                    .then(() => {
                        Ext.toast('执行成功')
                        onClose && onClose()
                        onSave && onSave()
                    })
                    .catch(errorMessage => Tyan.pubForm.showError(errorMessage))
        )
    }
    const { onSave, onClose, action, } = props
    const events = []
    switch (action) {
        case '司机确认.提交':
            events.push([doGetDriverInfo, {}, ({ optionsParas }) => optionsParas && { optionsParas }])
            break
        case '接收确认.提交':
        case '请假初审.提交':
        case '请假审核.提交':
        case '请假复审.提交':
        case '请假审批.提交':
        case '请假核准.提交':
        case '请假批准.提交':
        case '请假完成.销假申请':

        case '销假初审.提交':
        case '销假审核.提交':
        case '销假复审.提交':
        case '销假核准.提交':
        case '销假批准.提交':

        case '请假申请.驳回':
        case '接收确认.驳回':
        case '请假初审.驳回':
        case '请假审核.驳回':
        case '请假复审.驳回':
        case '请假审批.驳回':
        case '司机确认.驳回':
        case '请假核准.驳回':
        case '请假批准.驳回':

        case '销假申请.驳回':
        case '销假初审.驳回':
        case '销假审核.驳回':
        case '销假复审.驳回':
        case '销假核准.驳回':
        case '销假批准.驳回':
            break
        default:
            handlerConfirm()
            return
    }
    return events
}
class LeaveApplyAction extends React.Component {
    state = {
        errorMessage: null,
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    componentDidMount = () => {
        this.handlerInitValue(this.props.id)
    }

    handlerInitValue = (id) => {
        const { onSave, onClose, dispatch, action, 假勤项目, objGaugeInfo, gaugeType, sampleDispose, businessType, applicationType, haveCalibrationReport, events } = this.props
        if (events.length > 0) {
            doDispatchs(dispatch, events)
                .then(ret => {
                    this.setState({ ...ret })
                })
                .catch(errorMessage => Tyan.pubForm.showError(errorMessage, onClose))
        }
    }

    handlerSave = () => {
        const { onSave, onClose, dispatch, id, action } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        if (action == '销假批准.驳回' && !values.驳回原因) {
            Ext.toast('驳回原因不能为空')
            return
        }
        doOneDispatch(dispatch, { fn: doLeaveApplyFlow, data: { id, action, changedValues基本信息 } })
            .then(() => {
                Ext.toast('执行成功')
                onClose && onClose()
                onSave && onSave()
            })
            .catch((err) => Tyan.pubForm.showError(err))
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { onClose, 假勤项目, 出差天数 } = this.props
        console.log('values.出差是否需要上传报告1',values.出差是否需要上传报告)

        switch (this.props.action) {
            case '请假申请.驳回':
            case '接收确认.驳回':
            case '请假初审.驳回':
            case '请假审核.驳回':
            case '请假复审.驳回':
            case '请假审批.驳回':
            case '司机确认.驳回':
            case '请假核准.驳回':
            case '请假批准.驳回':
            case '销假申请.驳回':
            case '销假初审.驳回':
            case '销假审核.驳回':
            case '销假复审.驳回':
            case '销假核准.驳回':
            case '销假批准.驳回':
                return values.驳回原因
            case '请假批准.提交':
                    return 假勤项目 == "出差" && 出差天数 > 1 ? values.出差是否需要上传报告 : true
        }

        return true 
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        const { 假勤项目, 出差天数 } = this.props
        console.log('出差天数',出差天数)
        console.log('values.出差是否需要上传报告',values.出差是否需要上传报告)

        switch (this.props.action) {
            case '司机确认.提交':
                return [
                    { _select: '车牌号码', editable: true, forceSelection: false, },
                    { _select: '驾驶员', editable: true, forceSelection: false, },
                    { _text: '审核意见', maxRows: 3 },
                ]
            case '请假完成.销假申请':
                return [
                    { _text: '销假申请原因', maxRows: 3 },
                    { _files: '附件', },
                    { _text: '备注', maxRows: 3 },
                ]
            case '接收确认.提交':
            case '请假初审.提交':
            case '请假审核.提交':
            case '请假复审.提交':
            case '请假审批.提交':
            case '请假核准.提交':
            case '请假批准.提交':
                return [
                    { _text: '审核意见', maxRows: 3 },
                    { _radio: '出差是否需要上传报告',  items: ['是', '否'], required: true, cdt:()=> 假勤项目 == "出差" && 出差天数 > 1 },
                ]
            case '销假初审.提交':
            case '销假审核.提交':
            case '销假复审.提交':
            case '销假核准.提交':
            case '销假批准.提交':
                return [
                    { _text: '审核意见', maxRows: 3 },
                ]
            case '请假申请.驳回':
            case '接收确认.驳回':
            case '请假初审.驳回':
            case '请假审核.驳回':
            case '请假复审.驳回':
            case '请假审批.驳回':
            case '司机确认.驳回':
            case '请假核准.驳回':
            case '请假批准.驳回':

            case '销假申请.驳回':
            case '销假初审.驳回':
            case '销假审核.驳回':
            case '销假复审.驳回':
            case '销假核准.驳回':
            case '销假批准.驳回':
                return [
                    { _text: '驳回原因', required: true, maxRows: 3 },
                ]
        }
        return []
    }
    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const { id } = initValues基本信息
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !canSave },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}
const ConnectedLeaveApplyAction = connect()(LeaveApplyAction)
const doLeaveApplyAction = (dispatch, title, props) => {
    const events = doPrepare(dispatch, props)
    events && Tyan.pubForm.showDialog(title, ConnectedLeaveApplyAction, { ...props, events })
}
export { doLeaveApplyAction }